import { render, staticRenderFns } from "./TypeBarClinicManage.vue?vue&type=template&id=e7563624&scoped=true"
import script from "./TypeBarClinicManage.vue?vue&type=script&lang=js"
export * from "./TypeBarClinicManage.vue?vue&type=script&lang=js"
import style0 from "./TypeBarClinicManage.vue?vue&type=style&index=0&id=e7563624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7563624",
  null
  
)

export default component.exports